import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTextFlowStore } from '../stores/textFlowStore'

/**
 * The deck screen's «Добавить текст» (handoff §8, §19.6): opens the text creation
 * flow as «Новый текст» with this deck preset as the destination, and with the
 * deck as the place leaving the flow returns to. The learner can still change the
 * destination at step 3.
 */
export function useAddTextToDeck(deck: { id: string; title: string }): () => void {
  const navigate = useNavigate()
  const location = useLocation()
  const { id, title } = deck
  const origin = location.pathname + location.search
  return useCallback(() => {
    useTextFlowStore.getState().start('essay', origin, { id, title })
    navigate('/texts/new')
  }, [navigate, origin, id, title])
}
